<div *ngIf="reportType == 'unpaidOutstandingInDetails'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">
    <button mat-raised-button color="primary"
            (click)="exportExcel('Unpaid_Outstanding_InDetails_Report')">
      Export
    </button>

    <button class="btn btn-primary" (click)="printPageA4()">Print</button>

    <button mat-button mat-dialog-close>Close</button>
  </div>

  <!-- PRINT AREA -->
  <div id="print-section">

    <!-- ================= FIRST PAGE HEADER ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;">

        <thead>

          <!-- TITLE ROW -->
          <tr>
            <td colspan="2" style="font-size:18px; font-weight:bold; padding:8px;text-align:center;border-left:1px solid black;border-top:1px solid black;border-right:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था
            </td>

            <td colspan="3" style="font-size:20px; font-weight:bold; padding:8px; text-align:center;border-right:1px solid black;border-top:1px solid black;">
              Book Outstanding Report 
            </td>

            <td colspan="4" style="font-size:18px; padding:8px; text-align:right;font-weight:bold;border-top:1px solid black;border-right:1px solid black;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <!-- SUBTITLE -->
          <tr style="border-top:1px solid black;">
            <td colspan="2" style="font-size:18px; padding:8px; text-align:center; font-weight:bold;border-right:1px solid black;border-left:1px solid black;">
              विवेक पुस्तक प्रकाशन
            </td>

            <td colspan="3" style="font-size:18px; padding:8px; text-align:center; font-weight:bold;border-right:1px solid black;">
              Unpaid Outstanding In Details
            </td>

            <td colspan="4" style="font-size:16px; padding:8px; text-align:right; white-space:nowrap;font-weight:bold;border-right:1px solid black;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }}  
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

        </thead>

      </table>
    </div>

    <!-- ================= MAIN TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- COLUMN HEADERS — WILL REPEAT ON EVERY PAGE -->
      <thead class="repeat-header">
        <tr style="font-weight:bold; ">

          <th style="border:1px solid black; padding:6px; font-size:16px;">Invoice No</th>
          <th style="border:1px solid black; padding:6px; font-size:16px;">Invoice Date</th>

          <th style="border:1px solid black; padding:6px; font-size:16px; width:330px;">
            Book Seller Name
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px;">Contact No</th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Invoice Amt</th>
          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Received Amt</th>
          <!-- <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Credit Amt</th> -->
          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Unpaid Amt</th>

        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody *ngFor="let data of UnpaidOutstandingInDetailFormBeans">

        <!-- OFFICE REP NAME -->
        <tr >
          <td colspan="8" 
              style="border:1px solid black; font-size:16px;  padding:8px; text-align:center;font-weight:bold;">
            Office Representative: {{ data.off_rep_name }}
          </td>
        </tr>

        <!-- REP LEVEL -->
        <ng-container *ngFor="let data1 of data.rep_data">

          <tr >
            <td colspan="8" 
                style="border:1px solid black; padding:8px; font-size:14px; font-weight:bold;">
              Representative: {{ data1.rep_name }} ({{ data1.rep_mobile_no }})
            </td>
          </tr>

          <!-- INVOICE ROWS -->
          <tr *ngFor="let data2 of data1.inv_data">
            <td style="border:1px solid black; padding:6px;">{{ data2.invoice_no }}</td>
            <td style="border:1px solid black; padding:6px;">{{ data2.invoice_date }}</td>

            <td style="border:1px solid black; padding:6px; text-align:left;
                       max-width:330px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;"
                title="{{data2.book_seller_name}}">
              {{ data2.book_seller_name }}
            </td>

            <td style="border:1px solid black; padding:6px;">{{ data2.book_seller_mobile_no }}</td>

            <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.inv_amt }}</td>
            <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.rcv_amt || '0' }}</td>
            <!-- <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.credit_amt }}</td> -->
            <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.unpaid_amt }}</td>
          </tr>

          <!-- REPRESENTATIVE TOTAL -->
          <tr >
            <td colspan="4" 
                style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              Representative Total: {{ data1.rep_name }}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.inv_amt_total }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.net_amt_total }}
            </td>
            <!-- <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.crdt_amt_total }}
            </td> -->
            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.unpaid_amt_total }}
            </td>
          </tr>

        </ng-container>

        <!-- OFFICE REPRESENTATIVE TOTAL -->
        <tr >
          <td colspan="4" 
              style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            Office Representative Total: {{ data.off_rep_name }}
          </td>

          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_inv_amt_total }}
          </td>
          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_net_amt_total }}
          </td>
          <!-- <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_crdt_amt_total }}
          </td> -->
          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_unpaid_amt_total }}
          </td>
        </tr>

      </tbody>

      <!-- ================= GRAND TOTAL ================= -->
    
        <tr style="background:#c8753f; color:white; font-weight:bold; font-size:17px;">
          <td colspan="4" style="border:1px solid black; padding:8px; text-align:right;">
            Grand Total:
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDTotal }}
          </td>
          <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDNetAmtTotal }}
          </td>
          <!-- <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDCrdtTotal }}
          </td> -->
          <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDUnPaidTotal }}
          </td>
        </tr>
      

    </table>

  </div>

</div>

